module.exports = __webpack_public_path__ + "img/dino_sad.c72a4c32.png";